module.exports = __webpack_public_path__ + "img/gin-sour.60e0b44e.jpg";